import { useTransparencyControl } from '../hooks/use-transparency-control'
import type { TransparencyControlProps } from '../types/effect-control-props'
import { EffectSliderField } from './effect-slider-field'

/** Transparency 0–100% for every selected object (group shells apply to their descendants). */
export function EffectsPanelTransparency(props: TransparencyControlProps) {
  const field = useTransparencyControl(props)

  return (
    <EffectSliderField
      {...field}
      label="Transparency"
      ariaLabel="Transparency percent"
      errorId="transparency-input-error"
      suffix="%"
    />
  )
}
